import { IBranch } from 'app/shared/Domains/branch';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebcamImage } from 'ngx-webcam';
import { ConfirmationService, MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { MemberService } from 'common/services/member.service';
import { Configuration } from 'config/config';
import { IAddress } from '../../Domains/address';
import { ICompany } from '../../Domains/company';
import { Customerstrainer } from '../../Domains/Customerstrainer';
import { IMemberFeeDetails } from '../../Domains/feeDetail';
import { IUser } from '../../Domains/IUser';
import { IMember } from '../../Domains/member';
import { IMemberContact } from '../../Domains/memberContact';
import { IMemberEmergencyContact } from '../../Domains/memberEmergencyContact';
import { IMemberFreezeDetail } from '../../Domains/memberFreezeDetail';
import { IPackageBuider } from '../../Domains/packageBuilder';
import { ISettings } from '../../Domains/settings';
import { ReceiptPrintComponent } from '../../receipt/receipt-print/receipt-print.component';
import globalVariable from "../../../../globalVariable/globalVariable.json";
import { IRequest } from 'app/shared/Domains/request';
import { AppUtils } from 'common/services/app.util';
import {
    buildCreateCustomerPayload,
    buildMemberUpdatePayload,
    customerCreateUrl,
    customerGetUrl,
    customerUpdateUrl,
} from 'common/services/member-update-payload.util';
import { buildApproveEnquiryPayload } from 'common/services/enquiry-update-payload.util';
import { IEnquiry } from 'app/shared/Domains/enquiry';
import { IVisitor } from 'app/shared/Domains/visitor';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: 'app-add-single-signup',
    templateUrl: './add-single-signup.component.html',
    host: { "(window:keyup)": "addSingleHotkeys($event)", "(window:click)": "hotClick($event)" },
    styleUrls: ['./add-single-signup.component.css']
})
export class AddSingleSignupComponent implements OnInit {
    restrictCNICInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  const numericValue = input.value
    .replace(/[^0-9]/g, '')
    .slice(0, 13);

  input.value = numericValue;
  this.member.CNIC = numericValue;
}
    @ViewChild(ReceiptPrintComponent)
    private receiptComponent: ReceiptPrintComponent;
    member: IMember;
    @ViewChild('proceed') proceed: ElementRef;
    // @ViewChild("packageName", { static: false }) packageNameInput: ElementRef;
    @ViewChild("gender") genderControl: ElementRef;
    @ViewChild("dd") dropdown: any;
    packages: IPackageBuider[] = [];
    sourcePackages: IPackageBuider[];
    package: IPackageBuider;
    selectecPackage: IPackageBuider;
    errorExempleNumber: any;
    user: IUser;
    passwordType: string = "password";
    loading: boolean;
    isAgeValid: boolean = true;
    loadingMembership: boolean;
    items: any[];
    addProfileImage: any;
    fund: IMemberFeeDetails;
    freezeDetail: IMemberFreezeDetail;
    activeIndex: any;
    company: ICompany;
    branch: IBranch;
    uploadProfile: any;
    bool: boolean;
    uploadProfilePath: any;
    sortedTrainers: any[];
    Trainers: any[];
    sourceTrainers: any[];
    options: any[] = [];
    x: Boolean;
    registrationFund: IMemberFeeDetails;
    trainerFund: IMemberFeeDetails;
    memberIDS: any[];
    selectedOption: any;
    fundInvoice: IMemberFeeDetails;
    dialogVisibility: boolean;
    feeInvoiceDialog: boolean;
    statusOptions: any[];
    referralOptions: any[];
    referralOther:any;
    months: any[];
    years: any[];
    public webcamImage: WebcamImage = null;
    feesServicesCall: any[] = [];
    memeberServicesCall: any[] = [];
    noOfMembers: number = 1;
    index: number = 0;
    memberItems: any[] = [];
    members: IMember[] = [];
    isMembersRegistered: boolean = false;
    totalPackageFee: number = 0;
    totalRegistrationPackageFee: number = 0;
    totalTrainerFee: number = 0;
    existMembers: IMember[] = [];
    existMembersddOptions: any[] = [];
    existingMembersDialog: boolean = false;
    selectedExistMember: string;
    countries: any[] = [];
    @Input() subPackage: IPackageBuider;
    @Input() availablePackages: IPackageBuider[] = [];
    @Output('changeWizard') changeWizard: EventEmitter<any> = new EventEmitter();
    @Output('reverseWizard') reverseWizard: EventEmitter<void> = new EventEmitter<void>();
    @Output('feeData') feeData: EventEmitter<any> = new EventEmitter();
    invoicePrint: boolean = false;
    genderOptions: { label: string; value: string }[];
    focusedIdx: any;
    count: number = 0;
    isEmailExist: boolean = false;
    isEmailLoader: boolean = false;
    timer: any;
    enterSteps: any[];
    currentStep: any;
    isDisableOnTypeEmail: boolean = false;
    isNumberLengthValid: boolean = false;
    isGymShareMoreThanTrainerFee: boolean = false;
    requestId: string;
    request: IRequest;
    enquiry: IEnquiry;
    message: any;
    formattedNumber: string = '';
    sessionCount:any;
    currentUser = '';
    companySessionStorage = '';
    branchSessionStorage = '';
    isPhoneNumberValid: boolean = false;
    registerConfirmVisible = false;

    isJoiningDateLocked(): boolean {
        const isRestrictedBranch =
            this.branchSessionStorage == '646c533d4cf44878fcd1abb5' ||
            this.branchSessionStorage == '6992c3bf4cf88446d88b2161';
        const roleName = typeof this.user?.role === 'string'
            ? this.user.role
            : this.user?.role?.name;
        const isAdmin = roleName === 'Admin' || roleName === 'Super Admin';
        return isRestrictedBranch && !isAdmin;
    }

    goBack() {
        this.reverseWizard.emit();
    }
    enquiryId: string;
    enquiryIdRegistered: any = {
        id: ''
    };
    visitorId: string;
    visitor: IVisitor;
    phoneErrorMessage: boolean = true;
    memberSignUpForm: any;
    dateOfBirthError: boolean;
    maxDate: Date;
    selectedIdentityType: string = 'CNIC';
    bloodGroupOptions: any[] = [];

    constructor(
        private LanguageService: LanguageService,
        private router: Router,
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        public config: Configuration,
        private _http: HttpClient,
        private appServiceManager: AppServiceManager,
        private messageService: MessageService,
        private loader: NgxSpinnerService,

    ) { }
	setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AddSingleSignupComponent", label);
      }
      get matchingLimitPackages(): IPackageBuider[] {
  return (this.availablePackages || []).filter(
    (packageItem) =>
      Number(packageItem.noOfMembers) ===
      Number(this.subPackage?.noOfMembers)
  );
}
onPackageChange(selectedPackage: IPackageBuider) {
  if (!selectedPackage) {
    return;
  }

  this.subPackage = selectedPackage;
  this.noOfMembers = selectedPackage.noOfMembers;

  this.member.packageId = selectedPackage._id;
  this.member.packageName = selectedPackage.packageName;
  this.member.packageType = selectedPackage.packageType;
  this.member.monthFee = selectedPackage.packageFee.toString();
  this.member.customerPackageFee = selectedPackage.packageFee;
  this.member.registerationFee =
    selectedPackage.registerationFee.toString();

  if (this.member.freezeDetail) {
    this.member.freezeDetail.totalFreezingDays =
      selectedPackage.freezingDays;
  }
}

    ngOnInit() {
        this.bloodGroupOptions = [
            { label: "Select Blood Group", value: null },
            { label: "A+", value: "A+" },
            { label: "A-", value: "A-" },
            { label: "B+", value: "B+" },
            { label: "B-", value: "B-" },
            { label: "AB+", value: "AB+" },
            { label: "AB-", value: "AB-" },
            { label: "O+", value: "O+" },
            { label: "O-", value: "O-" }
        ];
        const today = new Date();
        today.setDate(today.getDate() - 1); // Set to yesterday
        this.maxDate = today;
        this.currentUser = localStorage.getItem('currentUser');
        const currentUseroBJ = JSON.parse(this.currentUser);
        this.companySessionStorage = currentUseroBJ.company;
        this.branchSessionStorage = currentUseroBJ.branch;
        this.branch = JSON.parse(localStorage.getItem('currentBranch'));
        console.log("this.companySessionStorage", this.companySessionStorage);
        this.route.queryParamMap
            .subscribe((params) => {
                this.requestId = params.get('requestid');
                if (this.requestId) {
                    this.getRequestById();
                }
            });
        this.route.queryParamMap
            .subscribe((params) => {
                this.enquiryId = params.get('enquiryid');
                if (this.enquiryId) {
                    this.getEnquiryById();
                }
            });
        this.route.queryParamMap
            .subscribe((params) => {
                this.visitorId = params.get('visitorid');
                if (this.visitorId) {
                    this.getVisitorById();
                }
            });

        this.InitObjects();
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;
        this.user = AuthService.getLoggedInUser();
        this.activeIndex = 0;
        this.member.feeDetails = [];
        this.member.joiningDate = new Date();
        this.member.profile = "";
        this.member.gender = "M";
        this.member.question1 = "NO";
        this.dialogVisibility = false;
        this.loading = false;
        this.sessionCount = 0;
        this.feeInvoiceDialog = false;
        this.x = false;
        this.member.registerationFee = "0";
        this.currentStep = -1;
        this.getTrainers();
        this.getCompany();
        this.getAutoMemberID();
        this.selectSubcription();
        const enquiry = this.route.snapshot.queryParamMap.get("enquiry");
        if (enquiry != null) {
            this.getEnquiryMember();
        }
    }

    onPhoneNumberChange(phoneNumber: string) {
        if(phoneNumber){
            this.isPhoneNumberValid = true;
        }
        if(phoneNumber.length >= 1){
            this.phoneErrorMessage = false;
        }else{
            this.phoneErrorMessage = true;
        }

      }

    getRequestById() {
        this.loading = true;
        this.appServiceManager
            .get("branches/" + AuthService.getLoggedInBranch() + "/customers/actions/requests/" + this.requestId)
            .subscribe((request: IRequest) => {
                this.request = request;

                this.member = Object.assign(this.member, this.request);
                delete this.member._id;

                // this.member.question1 = this.request.registrationDetail
                    // && this.request.registrationDetail.isCovidVaccinated
                    // && this.request.registrationDetail.isCovidVaccinated == true ? 'YES' : 'NO';

                // this.member.covidImageUrl = this.request.registrationDetail.covidImageUrl;
                this.member.CNIC = this.request.registrationDetail.CNIC;
                this.member.CNIC = this.request.registrationDetail.CNIC;
                this.member.dateOfBirth = new Date(this.request.dateOfBirth);

                this.loading = false;

                this.checkEmailExistEvent(this.member.email);
            },
                (error: { status: number; }) => {
                    this.loading = false;
                    if (error.status == 404) {
                        this.router.navigateByUrl('/requests-management');
                    }
                }
            );
    }
    getEnquiryById() {
        this.loading = true;
        const branchId = AuthService.getLoggedInBranch();
        this.appServiceManager
            .get('branches/' + branchId + '/customers/actions/enquiry/' + this.enquiryId)
            .subscribe((enquiry: IEnquiry) => {
                this.enquiry = enquiry;
                this.member = Object.assign(this.member, this.enquiry);
                this.member.contactDetail.contact=this.enquiry.contact;
                this.member.enquiryId=this.enquiry._id;
                delete this.member._id;
                this.loading = false;
                this.checkEmailExistEvent(this.member.email);
            },
                (error: { status: number; }) => {
                    this.loading = false;
                    if (error.status == 404) {
                        this.router.navigateByUrl('/enquiry-listing');
                    }
                }
            );
    }
    getVisitorById() {
        this.loading = true;
        const branchId = AuthService.getLoggedInBranch();
        this.appServiceManager
            .get('branches/' + branchId + '/visitors/' + this.visitorId)
            .subscribe((visitor: IVisitor) => {
                if (visitor) {
                    this.visitor = visitor;
                    this.member.name = visitor.name || this.member.name;
                    this.member.email = visitor.email || this.member.email;
                    if (visitor.gender) {
                        this.member.gender = visitor.gender === 'Female' ? 'F' : (visitor.gender === 'Male' ? 'M' : (visitor.gender || 'M'));
                    }
                    this.member.profile = this.member.gender === 'M' ? 'assets/layout/images/avatarBoyImage.png' : 'assets/layout/images/avatarGirlImage.png';
                    if (visitor.phone) {
                        this.member.contactDetail.contact = visitor.phone;
                    }
                    if (visitor.dateOfBirth) {
                        this.member.dateOfBirth = new Date(visitor.dateOfBirth);
                    }
                    delete this.member._id;
                    this.loading = false;
                    if (this.member.email) {
                        this.checkEmailExistEvent(this.member.email);
                    }
                } else {
                    this.loading = false;
                }
            },
                (error: { status: number; }) => {
                    this.loading = false;
                    if (error.status == 404) {
                        this.router.navigateByUrl('/visitors');
                    }
                }
            );
    }

    InitObjects() {
        this.sessionCount = 0;
        this.addProfileImage = "Upload";
        this.member = new IMember();
        this.company = new ICompany();
        this.member.contactDetail = new IMemberContact();
        this.freezeDetail = new IMemberFreezeDetail();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail.address = new IAddress();
        this.member.customerstrainer = new Customerstrainer();
        var currentDate = new Date();
        this.member.customerstrainer.dueDate = currentDate;
        this.member.settings = new ISettings();
        this.fund = new IMemberFeeDetails();
        this.fundInvoice = new IMemberFeeDetails();
        this.package = new IPackageBuider();
        this.user = new IUser();
        this.member.contactDetail.address.country = "Pakistan";
        // this.member.contactDetail.address.city = "Islamabad";
        this.statusOptions = [
            { label: "Select Fee Type", value: null },
            { label: "All", value: "All" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];

        this.months = [
            { label: "Select Month", value: null },
            { label: "January", value: 1 },
            { label: "Febuary", value: 2 },
            { label: "March", value: 3 },
            { label: "April", value: 4 },
            { label: "May", value: 5 },
            { label: "June", value: 6 },
            { label: "July", value: 7 },
            { label: "August", value: 8 },
            { label: "September", value: 9 },
            { label: "October", value: 10 },
            { label: "November", value: 11 },
            { label: "December", value: 12 },
        ];
        this.years = [
            { label: "Select Year", value: null },
            { label: "2015", value: 2015 },
            { label: "2016", value: 2016 },
            { label: "2017", value: 2017 },
            { label: "2018", value: 2018 },
            { label: "2019", value: 2019 },
            { label: "2020", value: 2020 },
            { label: "2021", value: 2021 },
            { label: "2022", value: 2022 },
            { label: "2023", value: 2023 },
            { label: "2024", value: 2024 },
            { label: "2025", value: 2025 },
            { label: "2026", value: 2026 },
            { label: "2027", value: 2027 },
            { label: "2028", value: 2028 },
            { label: "2029", value: 2029 },
            { label: "2030", value: 2030 },
            { label: "2031", value: 2031 },
            { label: "2032", value: 2032 },
            { label: "2033", value: 2033 },
            { label: "2034", value: 2034 },
            { label: "2035", value: 2035 },
            { label: "2036", value: 2036 },
            { label: "2037", value: 2037 },
            { label: "2038", value: 2038 },
            { label: "2039", value: 2039 },
            { label: "2040", value: 2040 },
        ];

        this.referralOptions = [
            { label: "Select Referral Source", value: null },
            { label: "Social Media", value: "Social Media" },
            { label: "Corporate", value: "Corporate" },
            { label: "Walk-In", value: "Walk-In" },
            { label: "Referral", value: "Referral" },
            { label: "Other", value: "Other" }
        ];

        if (this.index == 0) {
            this.enterSteps = [
                "memberName",
                "gender",
                "contact",
                "email",
                "street",
                "city",
                "country",
                "question1",
                "description",
                "proceed"
            ];
        } else if (this.index == 1) {
            this.enterSteps = [
                "selectTrainer",
                "trainerFee",
                "gymShare",
                // "trainerShare",
            ];
        }


    }

    setSessionCount(value: any) {
        this.sessionCount = value;
    }

    getEnquiryMember() {
        const parsed = JSON.parse(
            this.route.snapshot.queryParamMap.get("enquiry")
        );
        const enquiryId = typeof parsed === 'string' ? parsed : parsed?._id;
        const branchId = AuthService.getLoggedInBranch();
        this.appServiceManager.get('branches/' + branchId + '/enquiries/' + enquiryId).subscribe((res: any) => {
            if (res) {
                const enquiryObj = res;
                this.member = new IMember();
                this.member.contactDetail = new IMemberContact();
                this.member.contactDetail.address = new IAddress();
                this.member.contactDetail.address.street = enquiryObj.address;
                //this.member.contactDetail.address.city = "Islamabad";
                this.member.contactDetail.address.country = "Pakistan";
                this.member.customerstrainer = new Customerstrainer();
                this.member.name = enquiryObj.name;
                this.member.email = enquiryObj.email;
                this.member.gender = enquiryObj.gender == "Male" ? "M" : "F";
                this.member.profile = enquiryObj.gender == "Male" ? "assets/layout/images/avatarBoyImage.png" : "assets/layout/images/avatarGirlImage.png";
                this.member.contactDetail.contact = enquiryObj.contact;
                this.member.customerstrainer.totalFees = "0";
                this.member.question3 = "NO";
                // this.member.5.address = enquiryObj.address;
                this.member.profession = enquiryObj.profession;
                this.member.question2 = enquiryObj.question2;
                this.member.question1 = enquiryObj.question1;
                this.member.joiningDate = new Date();
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
            }
            this.loading = false;
        },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });



    }

    getAutoMemberID() {
        this.loadingMembership = true;
        let filter = {
            Member: this.member.tagNumber,
            company: this.user.company,
            branch: this.user.branch,
        };
        this.appServiceManager.post('branches/' + this.user.branch + '/customers/actions/get-membership', filter).subscribe(
            (member: any) => {
                if (member.memberShipTag != null) {
                    this.member.tagNumber = member.memberShipTag.toString();
                }
                this.loadingMembership = false;
            },
            (error: any) => {
                this.loadingMembership = false;
            }
        );
    }
    membershipValidation() {
        if (this.member.tagNumber != "") {
            this.appServiceManager
                .get(
                    "customers/membershipExistValidation/" +
                    this.member.tagNumber
                )
                .subscribe(
                    (res: string | any[]) => {
                        if (res.length > 0) {
                            this.x = true;
                        } else if (res.length == 1) {
                            this.x = true;
                        } else {
                            this.x = false;
                        }
                    },
                    (error: any) => { }
                );
        }
    }

    dropdownChange() {
        var data = this.Trainers.filter((x) => x._id === this.selectedOption);
        if (data.length > 0) {
            this.member.customerstrainer.trainerId = data[0]._id;
            this.member.customerstrainer.name = data[0].name;
            this.member.customerstrainer.dueDate = this.member.customerstrainer.dueDate ? this.member.customerstrainer.dueDate : new Date();
            this.member.customerstrainer.sessionCount = this.sessionCount;
            this.member.customerstrainer.totalFees = data[0].totalFees
                ? data[0].totalFees
                : 0;
            this.member.customerstrainer.trainerShare = data[0].trainerShare
                ? data[0].trainerShare
                : 0;
            this.member.customerstrainer.gymShare = data[0].gymShare
                ? data[0].gymShare
                : 0;
        } else {
            this.member.customerstrainer.trainerId = undefined;
            this.member.customerstrainer.name = undefined;
            this.member.customerstrainer.totalFees = undefined;
            this.member.customerstrainer.trainerShare = undefined;
            this.member.customerstrainer.gymShare = undefined;
        }
    }

    dropdownChange1(selectedMember: IMember) {
        var data = this.Trainers.find(
            (x) => x._id === selectedMember.customerstrainer.trainerId
        );
        var index = this.members.indexOf(selectedMember);
        // let memberInd  = this.members.find((x) => x._id === selectedMember._id);
        let memberInd = this.members.find(
            (x) => x.tagNumber === selectedMember.tagNumber
        );
        if (data != null) {
            if (this.member.gPTQuestion === "2P") {
                memberInd.question3 = "YES";
                memberInd.customerstrainer.trainerId = data._id;
                memberInd.customerstrainer.name = data.name;
                memberInd.customerstrainer.sessionCount = this.sessionCount;
                memberInd.customerstrainer.totalFees = "20000";
                memberInd.customerstrainer.trainerShare = data.trainerShare
                    ? data.trainerShare
                    : 0;
                memberInd.customerstrainer.gymShare = data.gymShare
                    ? data.gymShare
                    : 0;
            } else if (this.member.gPTQuestion === "3P") {
                memberInd.question3 = "YES";
                memberInd.customerstrainer.trainerId = data._id;
                memberInd.customerstrainer.name = data.name;
                memberInd.customerstrainer.sessionCount = this.sessionCount;
                memberInd.customerstrainer.totalFees = "15000";
                memberInd.customerstrainer.trainerShare = data.trainerShare
                    ? data.trainerShare
                    : 0;
                memberInd.customerstrainer.gymShare = data.gymShare
                    ? data.gymShare
                    : 0;
            } else if (this.member.gPTQuestion === "4P") {
                memberInd.question3 = "YES";
                memberInd.customerstrainer.trainerId = data._id;
                memberInd.customerstrainer.name = data.name;
                memberInd.customerstrainer.sessionCount = this.sessionCount;
                memberInd.customerstrainer.totalFees = "12000";
                memberInd.customerstrainer.trainerShare = data.trainerShare
                    ? data.trainerShare
                    : 0;
                memberInd.customerstrainer.gymShare = data.gymShare
                    ? data.gymShare
                    : 0;
            }
        }
        this.members[index] = memberInd;
        this.count++;
    }

    getTrainers() {
        this.sourceTrainers = [];
        this.sortedTrainers = [];
        this.loading = true;
        this.appServiceManager.get('branches/' + this.user.branch + '/users/actions/trainers').subscribe(
            (res: string | any[]) => {
                if (res.length > 0) {
                    this.setTrainerData(res);
                } else {
                    this.Trainers = [];
                    this.options.push({ label: "No Trainer Found", value: 0 });
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Trainer Record Found",
                    });
                }
                this.loading = false;
            },
            (error: any) => {
                this.loading = false;
                this.options.push({ label: "No Trainer Found", value: 0 });
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }

    setTrainerData(Trainers: string | any[]) {
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == false) {
                this.sortedTrainers.push(Trainers[i]);
            }
        }
        this.sortedTrainers.sort(function (a, b) {
            if (
                a.name.substring(0, 1).toLowerCase() <
                b.name.substring(0, 1).toLowerCase()
            ) {
                return -1;
            } else if (
                a.name.substring(0, 1).toLowerCase() >
                b.name.substring(0, 1).toLowerCase()
            ) {
                return 1;
            }
            return 0;
        });
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == true) {
                this.sortedTrainers.push(Trainers[i]);
            }
        }
        this.Trainers = this.sortedTrainers;
        this.sourceTrainers = this.sortedTrainers;
        this.Trainers = [...this.Trainers];
        this.sourceTrainers = [...this.sourceTrainers];
        this.options.push({ label: "Select Trainer", value: 0 });
        this.Trainers.forEach((trainer) => {
            this.options.push({ label: trainer.name, value: trainer._id });
        });
    }
    getCompany() {
        this.appServiceManager.get("companies/current").subscribe(
            (res: ICompany) => {
                if (res) {
                    this.company = res;
                } else {
                    this.company = new ICompany();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }

            },
            (error: any) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }
    validateSignup() {
        if (this.activeIndex === 0) {
            this.activeIndex = 1;
        } else if (this.activeIndex === 1) {
            this.activeIndex = 2;
        }
    }

    isFieldRequired(fieldName: string): boolean {
        return this.branch?.requiredFieldsCustomer?.[fieldName] === true;
    }

    validateMembersSignup(form: any) {
        if (form.controls['name'] && form.controls['name'].invalid) {
            const nameInput = document.getElementById('memberName');
            nameInput.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
        if (form.controls['dateOfBirth'] && form.controls['dateOfBirth'].invalid) {
            const nameInput = document.getElementById('joiningDate');
            nameInput.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
        if (form.controls['CNIC'] && form.controls['CNIC'].invalid) {
            const nameInput = document.getElementById('CNIC');
            if (nameInput) {
                nameInput.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center',
                });
            }
        }
        if (this.selectedIdentityType === 'Passport' && form.controls['passport'] && form.controls['passport'].invalid) {
            const nameInput = document.getElementById('passport');
            if (nameInput) {
                nameInput.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center',
                });
            }
        }
                if (form.valid) {
            if (this.index === 1) {
                this.index = 0;

                this.nextMembers();
                let ele = document.getElementsByClassName(
                    "p-label-active"
                )[1] as HTMLElement;
                ele.focus();
                if (!this.subPackage.isGreaterthanNoOfMembers) {
                    if (this.noOfMembers == this.members.length) {
                        this.isMembersRegistered = true;
                        let ele = document.getElementsByClassName(
                            "p-label-active"
                        )[1] as HTMLElement;
                        ele.focus();
                    }
                } else {
                    if (this.noOfMembers == this.members.length) {
                        this.isMembersRegistered = true;
                        let ele = document.getElementsByClassName(
                            "p-label-active"
                        )[1] as HTMLElement;
                        ele.focus();
                    }
                }
            } else if (this.index === 0) {
                this.index = 1;
                this.enterSteps = [
                    "selectTrainer",
                    "trainerFee",
                    "gymShare",
                    // "trainerShare",
                ];
                if (this.noOfMembers == this.members.length) {
                    this.isMembersRegistered = true;
                    let ele = document.getElementsByClassName(
                        "ui-label-active"
                    )[1] as HTMLElement;
                    ele.focus();
                }
            } else {
                this.index = 1;
            }
            this.trainerYesNoAutoFocus();
        }
        else {
            //  // Form validation error handling
            Object.keys(form.controls).forEach(controlName => {
                const control = form.controls[controlName];
                control.markAsTouched(); // Mark the control as touched to display the validation error messages
            });
        }
    }

    // pTrainerTab() {
    //     this.members.push(this.member);
    //     if (this.index === 1) {
    //         this.index = 0;
    //     } else {
    //         this.index = 1;
    //     }
    // }

    selectSubcription() {
        this.member.monthFee = this.subPackage.packageFee.toString();
        this.member.question3 = "NO";
        this.member.packageType = this.subPackage.packageType;
        this.member.packageName = this.subPackage.packageName;
        this.member.packageId = this.subPackage._id;
        this.member.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
        this.noOfMembers = this.subPackage.noOfMembers;
        this.member.registerationFee = this.subPackage.registerationFee.toString();
        for (let index = 1; index <= this.noOfMembers; index++) {
            this.memberItems.push({
                label: "Membership" + " " + index,
                command: (event: any) => {
                    this.activeIndex = 0;
                    this.validateSignup();
                },
            });
        }
        // member register button check if
        if (this.noOfMembers == 1) {
            this.isMembersRegistered = true;
        }
        // TODO: Commented By Mahsam
        // this.index = 1;
        this.validateSignup();
    }

    nextMembers() {
        // this.members.push(this.member);
        // this.loader.show();
        // setTimeout(() => {

        //     this.loader.hide();
        // }, 500);
        this.members.push(this.member);
        if (
            !this.subPackage.isGreaterthanNoOfMembers &&
            this.noOfMembers == this.members.length
        ) {
            this.isMembersRegistered = true;
        } else if (
            this.subPackage.isGreaterthanNoOfMembers &&
            this.noOfMembers == this.members.length
        ) {
            this.isMembersRegistered = true;
        }
        else {
            this.member = new IMember();
            setTimeout(() => {
                this.member.contactDetail.address.country = "Pakistan";
               // this.member.contactDetail.address.city = "Islamabad";
            }, 0);
            const newMembers = this.members.filter((x) => x._id == undefined); // get newly member to get the next tagNumber
            if (newMembers.length > 0) {
                this.member.tagNumber = String(
                    parseInt(newMembers[newMembers.length - 1].tagNumber) + 1
                ).toString();
            } else {
                this.getAutoMemberID();
            }
            this.member.packageId = this.subPackage._id;
            this.member.packageType = this.subPackage.packageType;
            this.member.packageName = this.subPackage.packageName;
            this.member.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
            this.member.profile = "assets/layout/images/avatarBoyImage.png";
            this.member.monthFee = this.subPackage.packageFee.toString();
            this.member.gender = "M";
            this.member.question3 = "NO";
            this.member.question1 = "NO";
            this.member.registerationFee =
                this.subPackage.registerationFee.toString();
            this.member.joiningDate = new Date();
            this.member.contactDetail = new IMemberContact();
            this.member.contactDetail.contact = "";
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.totalFees = "0";
            this.member.gPTQuestion = "";
            this.member.contactDetail.address = new IAddress();
            this.member.contactDetail.address.street = "";
            this.index = 0;
        }
    }

    clearCustomerTrainer() {
        for (let i = 0; i < this.members.length; i++) {
            this.members[i].customerstrainer = new Customerstrainer();
            this.members[i].customerstrainer.totalFees = null;
            this.members[i].question3 = "NO";
            this.count = 0;
        }
    }

    // feeInvoice() {
    //     var date = new Date();
    //     this.feeInvoiceDialog = true;
    //     let packageMonths = 0;
    //     this.totalPackageFee = 0;
    //     this.totalRegistrationPackageFee = 0;
    //     this.totalTrainerFee = 0;
    //     for (let index = 0; index < this.members.length; index++) {
    //         let member = this.members[index];
    //         let memberPackage: IPackageBuider = this.subPackage;
    //         member.packageId = memberPackage._id;
    //         member.packageType = memberPackage.packageType;
    //         // Month Wise Package: per Month Fee and whole package fee.
    //         if (
    //             memberPackage.packageType === "Month Wise Package" &&
    //             memberPackage.packageFeeType === "whole package fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee = parseInt(member.monthFee);
    //         } else if (
    //             memberPackage.packageType === "Month Wise Package" &&
    //             memberPackage.packageFeeType === "per Month Fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee =
    //                 packageMonths * parseInt(member.monthFee);
    //         }
    //         // Person Wise Package: per person Fee and whole package fee.
    //         else if (
    //             memberPackage.packageType === "Person Wise Package" &&
    //             memberPackage.packageFeeType === "whole package fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / memberPackage.noOfMembers
    //             ).toString();
    //             member.customerPackageFee = parseInt(member.monthFee);
    //         } else if (
    //             memberPackage.packageType === "Person Wise Package" &&
    //             memberPackage.packageFeeType === "per Person Fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee =
    //                 packageMonths * parseInt(member.monthFee);
    //         } else {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee = parseInt(member.monthFee);
    //         }

    //         this.fund = new IMemberFeeDetails();
    //         this.fund.invoice = Math.round(Math.random() * 1000).toString();
    //         this.fund.day = new Date(member.settings.dueDate).getDate().toString();
    //         this.fundInvoice.invoice = this.fund.invoice;
    //         this.fundInvoice.date = date;
    //         this.fund.year = date.getFullYear();
    //         this.fund.month = date.getMonth() + 1;
    //         this.fund.pay = this.totalPackageFee;
    //         this.fund.date = new Date();
    //         // if per person registartion fee
    //         if (memberPackage.registerationFee != 0) {
    //             member.registerationFee =
    //                 memberPackage.registerationFee.toString();
    //             if (
    //                 memberPackage.packageRegFeeType ===
    //                 "per Person Registration Fee"
    //             ) {
    //                 this.registrationFund = { ...this.fund };
    //                 this.registrationFund.memberId = member._id;
    //                 this.registrationFund.pay = memberPackage.registerationFee;
    //                 this.registrationFund.status = "Registration Fee - Paid";
    //                 this.feesServicesCall.push(
    //                     this.appServiceManager.post(
    //                         "customers/payFund",
    //                         this.registrationFund
    //                     )
    //                 );
    //                 this.totalRegistrationPackageFee +=
    //                     this.subPackage.registerationFee;
    //             } //if whole package registartion fee
    //             else if (
    //                 memberPackage.packageRegFeeType ===
    //                 "whole package Registration fee" &&
    //                 this.members.length === 0
    //             ) {
    //                 this.registrationFund = { ...this.fund };
    //                 this.registrationFund.memberId = member._id;
    //                 this.registrationFund.pay = Math.round(
    //                     memberPackage.registerationFee /
    //                     memberPackage.noOfMembers
    //                 );
    //                 this.registrationFund.status = "Registration Fee - Paid";
    //                 this.feesServicesCall.push(
    //                     this.appServiceManager.post(
    //                         "customers/payFund",
    //                         this.registrationFund
    //                     )
    //                 );
    //                 this.totalRegistrationPackageFee +=
    //                     this.subPackage.registerationFee;
    //             }
    //         }

    //         // trainer fees add
    //         if (member.question3 === "YES") {
    //             this.trainerFund = { ...this.fund };
    //             this.trainerFund.memberId = member._id;
    //             this.trainerFund.pay = Math.round(
    //                 parseInt(member.customerstrainer.totalFees)
    //             );
    //             this.trainerFund.status = "Trainer Fee - Paid";
    //             this.feesServicesCall.push(
    //                 this.appServiceManager.post(
    //                     "customers/payFund",
    //                     this.trainerFund
    //                 )
    //             );
    //             this.totalTrainerFee += this.trainerFund.pay;
    //         }

    //         for (let index = 0; index <= packageMonths - 1; index++) {
    //             var terminDate = new Date();
    //             let fund = new IMemberFeeDetails();
    //             fund.memberId = member._id;
    //             fund.invoice = this.fund.invoice;
    //             terminDate.setMonth(terminDate.getMonth() + index);
    //             fund.month = terminDate.getMonth() + 1;
    //             fund.date = this.fundInvoice.date;
    //             fund.pay = parseInt(member.monthFee);
    //             fund.day = this.fund.day;
    //             fund.year = terminDate.getFullYear();
    //             fund.status = "Monthly Fee - Paid";
    //             this.feesServicesCall.push(
    //                 this.appServiceManager.post("customers/payFund", fund)
    //             );
    //             this.totalPackageFee += fund.pay;
    //         }
    //     }
    // }

    getPackageByID() {
        this.appServiceManager.get("branches/" + this.user.branch + "/package-builders/" + this.member.packageId).subscribe((res: any) => {
          this.selectecPackage = res;
          this.loading = false;
        },
        (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }

    reverse() {
        if (this.activeIndex === 1) {
            this.activeIndex = 0;
        } else if (this.activeIndex === 2) {
            this.activeIndex = 1;
        }
    }
    togglePasswordType() {
        if (this.passwordType === "password") {
            this.passwordType = "text";
        } else {
            this.passwordType = "password";
        }
    }

    validateDetail(member: IMember) {
        // if (parseInt(member.registerationFee) >= 0 && parseInt(member.monthFee) >= 0) {
        if (
            member.question3 === "YES" &&
            parseInt(member.customerstrainer.totalFees) >= 0
        ) {
            return true;
        } else if (member.question3 === "NO") {
            member.customerstrainer.totalFees = '0';
            return true;
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Complete Fields Properly",
            });
            return false;
        }
        // } else {
        //   this.messageService.clear();
        //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: "Fees Should be Greater than zero" });
        //   return false;
        // }
    }
    onBloodGroupChange($event) {
        console.log("bloodGroup", $event);
        this.member.bloodGroup = $event.value;
    }
    signup() {
        this.feesUpdate();
        var check = this.membersAdd();
        if (check) {
            this.registerConfirmVisible = true;
        }
    }

    async confirmSignup(): Promise<void> {
        this.registerConfirmVisible = false;
        this.members = [];
        // this.loader.show();
        this.showSpinner('mainLoader');
        let res = [];
        for (let index = 0; index < this.memeberServicesCall.length; index++) {
            const element = this.memeberServicesCall[index];
            let promiseReturn = await element.toPromise();
            res.push(promiseReturn);
        }
        // forkJoin(this.memeberServicesCall).subscribe(
        //     (res: any) => {
        res.forEach((data) => {
            // this.validateMember(newMember);
            // this.fund.pay = parseInt(member.monthFee);
            // newMember.dateOfBirth = new Date(data.customer.dateOfBirth);
            // newMember.joiningDate = new Date(data.customer.joiningDate);
            // newMember.settings.dueDate = new Date(data.customer.joiningDate);
            if (data.customer) {
                this.enquiryIdRegistered.id = data.customer._id;
                if (data.customer.settings === null || data.customer.settings === undefined) {
                    data.customer.settings = new ISettings();
                    data.customer.settings.dueDate = new Date();
                } else if (data.customer.settings.dueDate === null || data.customer.settings.dueDate === undefined) {
                    data.customer.settings = new ISettings();
                    data.customer.settings.dueDate = new Date();
                }

                // this.activeIndex = 2;


                const enquiryObj = JSON.parse(
                    this.route.snapshot.queryParamMap.get("enquiry")
                );
                if (enquiryObj != undefined) {
                    this.changeWebEnquiryStatus(enquiryObj);
                }

                this.messageService.clear();
                this.messageService.add({
                    severity: "success",
                    summary: "Success Message",
                    detail: "Member Successfully Registered",
                });
                setTimeout(() => {
                    this.collectFeeButtonFocus();
                }, 500);


                if (this.requestId) {
                    this.updateRequest();
                }
                if (this.enquiryId) {
                    this.updateEnquiry();
                }
                if (this.uploadProfile) {
                    const file = AppUtils.base64ToFile(this.uploadProfile, `${this.member.name}.png` + ":" + this.companySessionStorage + ":" + this.branchSessionStorage);
                    this.uploadCustomerImage(file, data.customer);
                }else{
                    this.members.push(data.customer);
                    this.feeData.emit(this.members);
                    this.changeTab();
                    this.loader.hide();
                }

            } else if (data.customer == null) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: data.error,
                });
                this.hideSpinner('mainLoader');
            }
        });
        // },
        // (error) => {
        //     this.loader.hide();
        //     this.company = new ICompany();
        //     this.messageService.clear();
        //     this.messageService.add({
        //         severity: "error",
        //         summary: "Error Message",
        //         detail: error,
        //     });
        // }
        // );
    }

    cancelSignupConfirmation(): void {
        this.registerConfirmVisible = false;
        if (this.member.question3 == 'YES') {
            this.trainerRadioChangeFocus();
        } else {
            this.trainerYesNoAutoFocus();
        }
    }


    updateRequest() {
        this.loading = true;
        this.appServiceManager
            .post(`branches/${AuthService.getLoggedInBranch()}/requests/${this.requestId}/actions/approve`, {})
            .subscribe(
                (data: any) => {
                    this.loading = false;
                    // this.approvalMessages();

                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info", summary: "Info Message", detail: "Something Went Wrong",
                    });
                }
            );
    }
    updateEnquiry() {
        const branchId = AuthService.getLoggedInBranch();
        if (!branchId || !this.enquiry?._id || !this.enquiryIdRegistered?.id) {
            return;
        }
        this.loading = true;
        this.appServiceManager
            .post(
                `branches/${branchId}/enquiries/${this.enquiry._id}/actions/approve`,
                buildApproveEnquiryPayload(this.enquiryIdRegistered.id),
            )
            .subscribe(
                (data: any) => {
                    this.loading = false;
                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info", summary: "Info Message", detail: "Something Went Wrong",
                    });
                }
            );
    }

    // approvalMessages() {

    //     const payload = {
    //         name: this.member.name,
    //         mobile: this.member.contactDetail.contact,
    //         email: this.member.email,
    //         company: this.companySessionStorage,
    //         branch: this.branchSessionStorage

    //     };
    //     this.appServiceManager
    //         .post("registrationApprovalMessages", payload)
    //         .subscribe(
    //             (_res: any) => { },
    //         );
    // }

    uploadCustomerImage(file: any, member: any | Blob, isAddMode = false) {
        let formData: FormData = new FormData();
        if (file) {

            formData.append("customerImage", file, file.name);
            formData.append("isThumb", "true");
            formData.append("memberId", member._id);
            formData.append("company", this.companySessionStorage);
            formData.append("branch", this.branchSessionStorage);
            formData.append("isAddMode", isAddMode.toString());

            this.appServiceManager.post(`branches/${AuthService.getLoggedInBranch()}/customers/upload`, formData)
                .subscribe(
                    (res: any) => {
                        member.profile=res.profile;
                        this.members.push(member);
                        this.feeData.emit(this.members);
                        this.changeTab();
                        this.loader.hide();
                    },
                    (error: any) => {
                        this.messageService.clear();
                        this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
                    }
                );
        }
    }

    changeTab() {
        this.changeWizard.emit();
    }

    changeWebEnquiryStatus(request: { _id: string; }) {
        this.loading = true;
        this.appServiceManager.get('enquiry/changeWebEnquiryStatus/' + request._id).subscribe(() => {
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }

    feesUpdate() {
        if (this.subPackage.packageName === "") {
            let packageMonths = 0;
            this.totalPackageFee = 0;
            for (let index = 0; index < this.members.length; index++) {
                let member = this.members[index];
                let memberPackage: IPackageBuider = this.subPackage;
                member.packageId = memberPackage._id;
                member.packageType = memberPackage.packageType;
                // Month Wise Package: per Month Fee and whole package fee.
                if (
                    memberPackage.packageType === "Month Wise Package" &&
                    memberPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;

                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                } else if (
                    memberPackage.packageType === "Month Wise Package" &&
                    memberPackage.packageFeeType === "per Month Fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee =
                        packageMonths * parseInt(member.monthFee);
                }
                // Person Wise Package: per person Fee and whole package fee.
                else if (
                    memberPackage.packageType === "Person Wise Package" &&
                    memberPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / memberPackage.noOfMembers
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                } else if (
                    memberPackage.packageType === "Person Wise Package" &&
                    memberPackage.packageFeeType === "per Person Fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee =
                        packageMonths * parseInt(member.monthFee);
                } else {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                }
            }
        }
    }

    membersAdd() {
        if (this.members.length === 0) {
            this.member.customerstrainer.dueDate = new Date(this.member.joiningDate);
            this.members.push(this.member);
        }

        this.memeberServicesCall = [];
        var check = true;
        this.member.customerstrainer.sessionCount = this.sessionCount;
        this.member.customerstrainer.remainingSessionCount = parseInt(this.sessionCount);

        this.members.forEach((member) => {
            check = this.validateDetail(member);
            if (check) {
                this.setMemberData(member);
                member.company = AuthService.getLoggedInCompany();
                member.branch = AuthService.getLoggedInBranch();
                member.branchName = this.branch?.name || "";
                member.createdBy = this.user.name;
                member.type = 'Sign Up';
                member.scope = 'Member';
                member.initiatedFrom =  'Single Signup';
                if (member._id) {
                    //TODO: Existing member Update and add in package
                    this.memeberServicesCall.push(
                        this.appServiceManager.put(
                            customerUpdateUrl(AuthService.getLoggedInBranch(), member._id),
                            buildMemberUpdatePayload(member, {
                                modifiedBy: this.user?.name,
                                type: 'Sign Up',
                                includeCompanyBranch: true,
                            }),
                        )
                    );
                } else {
                    if (this.uploadProfile) {
                        delete member.profile;
                    }
                    this.memeberServicesCall.push(
                        this.appServiceManager.post(
                            customerCreateUrl(AuthService.getLoggedInBranch()),
                            buildCreateCustomerPayload(member),
                        ),
                    );
                }
            } else {
                return (check = false);
            }
        });

        return check;
    }

    validateMember(newMember: MemberService) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = new Date();
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = new Date();
        } else {
            this.member.settings.dueDate = new Date(
                this.member.settings.dueDate
            );
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        } else if (
            this.member.emergencyContact.medicalDetail === null ||
            this.member.emergencyContact.medicalDetail === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
    }
    setMemberData(member: IMember) {
        member.settings = new ISettings();
        member.settings.dueDate = member.joiningDate
            ? new Date(member.joiningDate)
            : new Date();
        this.freezeDetail.daysLeft = 0;
        this.freezeDetail.freezeDate = "";
        this.freezeDetail.isFreeze = false;
        this.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
        member.freezeDetail = this.freezeDetail;
    }
    finish() {
        this.router.navigateByUrl("members");
    }
    clearProfile($event: any) {
        this.member.profile = "assets/layout/images/avatarBoyImage.png";
    }

    captureImageDialogShow(type: any) {
        this.addProfileImage = type; // Upload | Cam
        this.dialogVisibility = true;
    }
    hideAddProfileImage() {
        this.dialogVisibility = false;
    }

    handleImagefromNewProfile(webcamImage: string) {
        if (webcamImage) {
            this.uploadProfile = webcamImage;
            this.member.profile = webcamImage;
            this.webcamImage = null;
            this.hideAddProfileImage();
        }
    }
    removeProfileImage() {
        this.uploadProfile = '';
        this.member.profile = '';
    }
    feeChange() {
        if (this.fund.status === "Trainer Fee - Paid") {
            if (
                this.member.customerstrainer &&
                parseInt(this.member.customerstrainer.totalFees) > 0
            ) {
                this.fund.pay = parseInt(
                    this.member.customerstrainer.totalFees
                );
                this.fundInvoice.pay = parseInt(
                    this.member.customerstrainer.totalFees
                );
            } else {
                this.fund.pay = 0;
                this.fundInvoice.pay = 0;
            }
        } else if (this.fund.status === "Monthly Fee - Paid") {
            this.fund.pay = parseInt(this.member.monthFee);
            this.fundInvoice.pay = parseInt(this.member.monthFee);
        } else {
            this.fund.pay = 0;
            this.fund.pay = 0;
        }
    }
    dateChange() {
        this.fund.pay = parseInt(this.member.monthFee);
        this.fundInvoice.pay = parseInt(this.member.monthFee);
    }

    uniqueArrayOfObject(array: any[], distinctMember: any[]) {
        // Filter by looking at the next objects if the object is present a second time
        array.forEach((data: { error: string; customer: { _id: any; }; }) => {
            if (data.error === "Fees Already Paid!") {
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: data.error + "of existing members",
                });
            } else {
                let member = distinctMember.find(
                    (x: { _id: any; }) => x._id == data.customer._id
                );
                if (!member) {
                    distinctMember.push(data.customer);
                }
            }
        });
        return distinctMember;
    }

    addFund() {
        this.dialogVisibility = false;
        this.confirmationService.confirm({
            message: "Are you sure you want to add member fee?",
            accept: () => {
                this.feeInvoiceDialog = false;
                if (this.members.length > 0) {
                    // this.loader.show();
                    this.showSpinner("mainLoader");
                    forkJoin(this.feesServicesCall).subscribe(
                        (res: any[]) => {
                            this.memeberServicesCall = [];
                            if (res) {
                                let distinctMembers: IMember[] = [];
                                distinctMembers = this.uniqueArrayOfObject(
                                    res,
                                    distinctMembers
                                );
                                distinctMembers.forEach((member) => {
                                    if (member._id) {
                                        this.memeberServicesCall.push(
                                            this.appServiceManager.get(
                                                customerGetUrl(AuthService.getLoggedInBranch(), member._id)
                                            )
                                        );
                                    }
                                });
                                this.getCustomerByID();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Member Fee Submitted",
                                });

                                this.activeIndex = 3;
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                                //this.feeInvoiceDialog = false;
                                this.activeIndex = 3;
                            }
                            // this.loader.hide();
                            this.hideSpinner('mainLoader');
                        },
                        (error) => {
                            // this.loader.hide();
                            this.hideSpinner('mainLoader');
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "warn",
                        summary: "Warning Message",
                        detail: "Monthly Fee Must be greater then zero.",
                    });
                    this.feeInvoiceDialog = false;
                    this.activeIndex = 4;
                }
            },
        });
    }

    addExistngMember() {
        // this.nextMembers();
        let member = this.existMembers.find(
            (x) => x._id === this.selectedExistMember
        );
        this.member = member;
        if (!member.contactDetail.address) {
            member.contactDetail.address = new IAddress();
            member.contactDetail.address.street = "";
        }
        this.member.registerationFee =
            this.subPackage.registerationFee.toString();
        this.member.packageId = this.subPackage._id;
        this.member.packageLogo = this.subPackage.logo;
        this.member.packageType = this.subPackage.packageType;
        this.member.packageName = this.subPackage.packageName;
        this.member.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
        this.member.monthFee = this.subPackage.packageFee.toString();
        this.member.joiningDate = new Date(this.member.joiningDate);
        this.member.dateOfBirth = new Date(this.member.dateOfBirth);
        this.member.customerstrainer = new Customerstrainer();
        this.member.customerstrainer.totalFees = "0";
        this.member.gPTQuestion = "";
        this.existingMembersDialog = false;
        this.selectedExistMember = "";
    }

    getCustomerByID() {
        this.members = [];
        forkJoin(this.memeberServicesCall).subscribe(
            (res: any) => {
                if (res) {
                    res.forEach((member: IMember) => {
                        member.joiningDate = new Date(member.joiningDate);
                        this.members.push(member);
                    });
                    this.getCompany();
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }

    onDateOfBirthChange() {
        const currentDate = new Date();
        if(this.member.dateOfBirth && new Date(this.member.dateOfBirth) > currentDate){
            this.dateOfBirthError = true;
        }else{
            this.dateOfBirthError = false;
        }
        this.getPackageByID();
        setTimeout(() => {
        if(this.selectecPackage && this.selectecPackage.ageGroupFrom){
            this.loading = true;
            this.checkAgeGroup();
        }
    }, 1000);
    }

    checkAgeGroup() {
        const validation = AppUtils.validateMemberAgeAgainstPackage(this.member, this.selectecPackage);
        if (validation.isValid) {
            console.log('Age is within the package age group.');
            this.isAgeValid = true;
        } else {
            this.isAgeValid = false;
            this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail:  "This package is not for this age group",
                    });
        }
    }

    printInvoice(): void {
        this.receiptComponent.printInvoice();
    }

    printCard(membercard: { tagNumber: string; }) {
        let membercardDetail = this.members.find(
            (x) => x.tagNumber == membercard.tagNumber
        );
        this.member = membercardDetail;
        setTimeout(() => {
            this.print();
        }, 200);
    }

    firstFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            setTimeout(() => {
                this.genderControl.nativeElement.focus();
            }, 3000);
            return;
        }
    }

    secondFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13) {
            e.preventDefault();
            control = document.getElementById("contact").focus();
            return;
        }
    }
    thirdFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("street");
            control.focus();
            return;
        }
    }

    phoneToEmailFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("email");
            control.focus();
            return;
        }
    }

    fourthFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("city");
            control.focus();
            return;
        }
    }

    fifthFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("country");
            control.focus();
            return;
        }
    }


    sixthFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("description");
            control.focus();
            return;
        }
    }

    trainerFeeFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 1) {
            e.preventDefault();
            control = document.getElementById("trainerFee");
            control.focus();
            return;
        }
    }

    getTrainerShare() {
        var x = parseInt(this.member.customerstrainer.totalFees) - parseInt(this.member.customerstrainer.gymShare);
        if (isNaN(x)) {
            this.member.customerstrainer.trainerShare = undefined;
        } else {
            if (x >= 0) {
                this.member.customerstrainer.trainerShare = x.toString();
                this.isGymShareMoreThanTrainerFee = false;

            } else {
                this.member.customerstrainer.trainerShare = undefined;
                this.isGymShareMoreThanTrainerFee = true;
            }

        }
    }

    onChangeTrainerFee() {
        this.member.customerstrainer.trainerShare = '0';
        this.member.customerstrainer.gymShare = '0';
    }

    gymShareFocus(e: { keyCode: number; preventDefault: () => void; }) {
        let control: any;
        if (e.keyCode == 13 && this.index == 1) {
            e.preventDefault();
            control = document.getElementById("gymShare");
            control.focus();
            return;
        }
    }

    trainerYesNoAutoFocus() {
        let ele: any;
        ele = document.getElementsByClassName("p-highlight")[3] as HTMLElement;
        ele.click();
        return;
    }

    // commentToProceedButtonClick($event) {
    //     if ($event.keyCode == 13 && !$event.shiftKey && !$event.ctrlKey && !$event.altKey) {
    //         $event.preventDefault();
    //         let ele: any = document.getElementById("proceed");
    //         if (!ele.disabled) {
    //             $event.preventDefault();
    //             ele.focus();
    //         } else {
    //             let control: any;
    //             $event.preventDefault();
    //             control = document.getElementById("memberName").focus();
    //             return;
    //         }
    //     }
    // }

    commentToProceedButtonClick($event: { keyCode: number; shiftKey: any; preventDefault: () => void; ctrlKey: any; altKey: any; }) {
        let ele: any = document.getElementById("proceed");
        if (ele.disabled) {
            if ($event.keyCode == 13 && !$event.shiftKey) {
                $event.preventDefault();
                let control: any;
                control = document.getElementById("memberName").focus();
            }
        } else if ($event.keyCode == 13 && !$event.shiftKey && !$event.ctrlKey && !$event.altKey) {
            let ele: any = document.getElementById("proceed");
            ele.focus();
        }
    }


    collectFeeButtonFocus() {
        let ele: any;
        ele = document.getElementsByClassName("p-button p-widget p-state-default p-corner-all")[0] as HTMLElement;
        ele.focus();
        return;
    }

    // hotkeys($event) {
    //     for (let m = 49, n = 0; n < this.packages.length; n++, m++) {
    //         if ($event.keyCode == m && this.activeIndex == 0) {
    //             let ele = document.getElementsByClassName("ui-c")[
    //                 n
    //             ] as HTMLElement;
    //             ele.click();
    //         }
    //     }

    //     for (let m = 49, n = 0; n < this.members.length; n++, m++) {
    //         if ($event.keyCode == m && this.activeIndex == 2) {
    //             let ele = document.getElementsByClassName("ui-c")[
    //                 n
    //             ] as HTMLElement;
    //             ele.click();
    //         }
    //     }

    //     if ($event.keyCode == 113 && this.index == 0 && this.activeIndex == 1) {
    //         this.existingMembersDialog = true;
    //     } else if (
    //         $event.keyCode == 115 &&
    //         this.existingMembersDialog == true
    //     ) {
    //         let ele = document.getElementById("aEM").children[0] as HTMLElement;
    //         ele.click();
    //     } else if ($event.keyCode == 115 && this.activeIndex == 1) {
    //         let ele = document.getElementById("selectTrainer")
    //             .children[0] as HTMLElement;
    //         // ele.click();
    //     } else if ($event.keyCode == 120) {
    //         let ele = document.getElementById("tFeeDueDate")
    //             .children[0] as HTMLElement;
    //         let ele2 = ele.children[1] as HTMLElement;
    //         // ele2.click();
    //     }

    //     else if ($event.keyCode == 70 && this.activeIndex == 3) {
    //         this.finish();
    //     }
    //     else if ($event.keyCode == 80 && this.activeIndex == 3) {
    //         this.printInvoice();
    //     }

    //     else if ($event.ctrlKey && $event.keyCode == 13 && this.activeIndex == 1 && this.index == 1) {
    //         let ele: any = document.getElementById("register");
    //         if (!ele.disabled) {
    //             this.signup();
    //         }
    //     }

    // }

    print(): void {
        let printContents: string, popupWin: Window;
        printContents = document.getElementById("ID-card").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>Gym ID Card</title>
        <style>
            .ID-card {
                width: 400px;
                height: 250px;
                margin: auto;
                position: relative;
                padding: 20px;
                border-radius: 10px;
                background-image: url("https://i.ibb.co/NL188dQ/white-wood.png");
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.35);
                z-index: 10;
                filter: opacity(95%);
            }

            .top-row {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 5px 0;
            }

            .flag {
                height: 10px;
                margin-right: 5px;
            }

            .card-title,
            .card-title-en {
                line-height: 100%;
            }

            .name,
            .name-en,
            .ID-number {
                font-weight: normal;
            }

            .card-title-en {
                margin-left: auto;
            }

            .middle-row {
                margin-top: 30px;
                display: inline-block;
            }

            .bottom-row {
                position: absolute;
                bottom: 20px;
            }

            .ID-photo {
                display: block;
                width: 100px;
                height: 128px;
                background-repeat: no-repeat;
                background-position: -90px center;
                background-size: 250px;
                position: absolute;
                top: 60px;
                right: 20px;
            }

            .series-number {
                writing-mode: vertical-rl;
                transform: rotate(180deg);
                position: absolute;
                right: -20px;
                bottom: 66px;
                z-index: 10;
            }

            .signature-title {
                position: absolute;
                bottom: 20px;
                right: 20px;
            }

            .signature {
                font-family: "Liu Jian Mao Cao", cursive;
                font-weight: 100;
                position: absolute;
                right: 40px;
                bottom: 35px;
            }

            .ID-number {
                line-height: 100%;
                margin-top: 5px;
            }

            .title {
                text-align: center;
                margin: 16px;
                font-weight: normal;
                font-size: 16px;
                width: 100%;
                position: absolute;
                bottom: 20px;
                z-index: 10;
            }
        </style>
    </head>
    <body>
        ${printContents}</body>
    </html>
    `);
    }

    checkEmailExistence() {
        if (this.member.email != undefined && this.member.email.length > 0) {
            this.isEmailLoader = true;
            const data = { email: this.member.email };
            this.appServiceManager.post(
                'branches/' + this.user.branch + '/customers/actions/check-email-existence',
                data,
            ).subscribe(
                (member: any) => {
                    if (member.isEmailExist) {
                        this.isEmailExist = true;
                        this.isDisableOnTypeEmail = true;
                        setTimeout(() => {
                            this.isEmailLoader = false;

                        }, 1000);
                    } else {
                        this.isEmailExist = false;
                        this.isDisableOnTypeEmail = false;

                        setTimeout(() => {
                            this.isEmailLoader = false;
                        }, 2000);
                    }
                },
                (error: any) => {

                }
            );
        }

    }

    checkEmailExistEvent(email: string | any[]) {
        this.isDisableOnTypeEmail = true;
        if (email?.length > 0) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.checkEmailExistence()
            }, 1000);
        } else {
            clearTimeout(this.timer);
            this.isEmailExist = false;
            this.isDisableOnTypeEmail = false;

        }

    }

    showSpinner(name: string) {
        this.loader.show(name);
    }

    hideSpinner(name: string) {
        this.loader.hide(name);
    }

    trainerRadioChangeFocus() {
        let ele: any = document.getElementById("selectTrainer")
        if (ele != null && ele != undefined && this.index == 1 && this.member.question3 === 'YES') {
            let ele = document.getElementById("selectTrainer").children[0] as HTMLElement;
            ele.click();
            this.currentStep = -1;
        }
    }

    addSingleHotkeys($event: { keyCode: number; shiftKey: any; ctrlKey: any; preventDefault: () => void; altKey: any; }) {
        if ($event.keyCode == 13 && this.activeIndex == 1 && !$event.shiftKey && !$event.ctrlKey) {
            var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
            var nextId = this.enterSteps[nextStep];
            let ele: any = document.getElementById(nextId)
            if (nextId == "gender") {
                let radioClassFocus: any = document.getElementsByClassName("p-highlight")[1] as HTMLElement;
                radioClassFocus.click();
                this.currentStep = 1;
            } if (nextId == "question1") {
                let radioClassFocus: any = document.getElementsByClassName("p-highlight")[2] as HTMLElement;
                radioClassFocus.click();
                this.currentStep = 7;
            } else if (ele != null && ele.disabled && nextId == "proceed" && !$event.shiftKey) {
                $event.preventDefault();
                document.getElementById("memberName").focus();
                this.currentStep = 0;

            } else if (ele != null && !ele.disabled && nextId == "proceed" && !$event.shiftKey && !$event.ctrlKey && !$event.altKey) {
                document.getElementById("proceed").click();
                this.currentStep = 0;

            } else if (ele != null && this.index == 1 && this.member.question3 === 'YES' && nextId == "selectTrainer") {
                let ele = document.getElementById("selectTrainer").children[0] as HTMLElement;
                ele.click();
                this.currentStep = 0;
            }
            else if (ele != null) {
                ele.focus();
                this.currentStep = nextStep;
            }
        } else if (this.index == 1 && $event.ctrlKey && $event.keyCode == 13) {
            let ele: any = document.getElementById("register");
            if (!ele.disabled) {
                ele.click();
            }
        }
    }

    hotClick($event: { target: { id: any; }; }) {
        let currentClickLocation = $event.target.id;
        let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
        if (indexOfClickField !== -1 && (currentClickLocation != "opt1" || currentClickLocation != "opt2")) {
            this.currentStep = indexOfClickField;
        } else {
            this.currentStep = this.currentStep;
        }
    }
}
